import React from 'react';
import './Footer.css';
import logo from './GK.png';
import {
  FaInstagram 
} from 'react-icons/fa6';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-left">
          <img src={logo} alt="Company Logo" className="footer-logo" />
        </div>
        <div className="footer-links">
          <p>&copy; {new Date().getFullYear()} GK Technologies. All rights reserved.</p>
        <div className="footer-social">
          <FaInstagram className="ig-icon" />
          <span className="ig-handle"> @gk_techs</span>
        </div>
        </div>
      </div>
      <div className="mt-2 text-sm text-zinc-600">
      By using Taren, you agree to our{" "}
      <a href="/terms" className="underline hover:opacity-80">Terms of Service</a>.
      </div>
    </footer>
  );
};

export default Footer;

